import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

// 初始化样式及全局样式
import 'normalize.css/normalize.css' // A modern alternative to CSS resets
import '@/styles/index.scss' // global css
import '@/icons' // icon
import ElementUI from 'element-ui'
import './styles.scss'
import './permission'
import './components/IcarePhone'
import * as global from './utils/golbal'

Vue.prototype.$global = global

//引入echart
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

//引入QRCode
import QRCode from 'qrcodejs2';
Vue.prototype.$qrCode = QRCode

import Viser from 'viser-vue'
Vue.use(Viser)

//引入dataV
import dataV from '@jiaminghi/data-view'
Vue.use(dataV)


import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)

Vue.use(ElementUI);
Vue.config.productionTip = false

import AMap from 'vue-amap'
Vue.use(AMap)
// 初始化地图
AMap.initAMapApiLoader({
  key: '78d07ee5b27ffceefaeef55bf54b5325',
  jscode :'a0fb20f3e7e5dac74e623e30e32c1920',
  plugin: [
    'AMap.Geolocation', 'AMap.Geocoder','AMap.DistrictSearch'],    // 插件集合
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


